import React from "react";
import "./companis.style.sass";
import { Button, Col, Icon, Row } from "rsuite";
import { connect } from "react-redux";
import { ChangeActiveLink } from "../../redux/site/site.actions";
import { Link } from "react-router-dom";

const CompanisComponent = ({ changeActive }) => {
  return (
    <div className="container">
      <div className="companis-main">
        {/* <Row>
                    <Col md={12} sm={24}>
                        <div className='companis-image'>
                            <Iran className='companis-svg' />
                            <Icon icon='search' className='pin1' />
                        </div>
                    </Col>
                    <Col md={12} sm={24}>
                        <div className='companis-texts'>
                            <div className='companis-texts-div'>
                                <h4>نمایندگی های <span>زیتونیکس</span></h4>
                                <Link to='/agencies'><Button onClick={()=>changeActive('agencies')}>نمایندگان</Button></Link>
                            </div>
                        </div>
                    </Col>
                </Row> */}
      </div>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => ({
  changeActive: (activeKey) => dispatch(ChangeActiveLink(activeKey)),
});

export default connect(null, mapDispatchToProps)(CompanisComponent);
